import React from 'react';
import { useState, useEffect } from 'react';
import { Routes, Route, useLocation } from "react-router-dom";
import Layout from './components/Layout';
import Home from './pages/Home';
import JakSeSbalitNaHory from './pages/JakSeSbalitNaHory';
import TipyNaVylety from './pages/TipyNaVylety';
import Kontakt from './pages/Kontakt';

import Beskydy from "./pages/pohori/Beskydy"
import Jeseniky from "./pages/pohori/Jeseniky"
import Krkonose from "./pages/pohori/Krkonose"
import Sumava from "./pages/pohori/Sumava"

import KamSeVydatVBeskydech from './pages/kamsevydat/KamSeVydatVBeskydech';
import KamSeVydatVJesenikach from './pages/kamsevydat/KamSeVydatVJesenikach';
import KamSeVydatVKrkonosich from './pages/kamsevydat/KamSeVydatVKrkonosich';
import KamSeVydatNaSumave from './pages/kamsevydat/KamSeVydatNaSumave';

import LysaHora from './pages/destinace-beskydy/LysaHora';
import Pustevny from './pages/destinace-beskydy/Pustevny';
import VelkyJavornik from './pages/destinace-beskydy/VelkyJavornik';
import Moravka from './pages/destinace-beskydy/Moravka';
import Javorovy from './pages/destinace-beskydy/Javorovy';
import Praded from './pages/destinace-jeseniky/Praded';
import Serak from './pages/destinace-jeseniky/Serak';
import KarlovaStudanka from './pages/destinace-jeseniky/KarlovaStudanka';
import Rejviz from './pages/destinace-jeseniky/Rejviz';
import MedvediVrch from './pages/destinace-jeseniky/MedvediVrch';
import Snezka from './pages/destinace-krkonose/Snezka';
import SpindleruvMlyn from './pages/destinace-krkonose/SpindleruvMlyn';
import CernaHora from './pages/destinace-krkonose/CernaHora';
import MumlavskyVodopad from './pages/destinace-krkonose/MumlavskyVodopad';
import Zaly from './pages/destinace-krkonose/Zaly';
import Plechy from './pages/destinace-sumava/Plechy';
import Boubin from './pages/destinace-sumava/Boubin';
import Polednik from './pages/destinace-sumava/Polednik';
import VitkuvHradek from './pages/destinace-sumava/VitkuvHradek';
import ChalupskaSlat from './pages/destinace-sumava/ChalupskaSlat';
import Profile from './pages/Profile';


import { useUserContext } from './context/userContext';
import Auth from './components/auth/Auth';
import ForgetPassword from './components/auth/ForgetPassword';
import EmailSended from './components/auth/EmailSended';
import PrivateRoute from './components/PrivateRoute';


const App = () => {

  const location = useLocation();

  const [displayLocation, setDisplayLocation] = useState(location);
  const [transitionStage, setTransistionStage] = useState("fadeIn");

  useEffect(() => {
    if (location !== displayLocation) setTransistionStage("fadeOut");
  }, [location, displayLocation]);

  return (
    <div
      className={`${transitionStage}`}
      onAnimationEnd={() => {
        if (transitionStage === "fadeOut") {
          setTransistionStage("fadeIn");
          setDisplayLocation(location);
        }
      }}
    >
      <Routes location={displayLocation}>
        <Route element={<Layout />}>
          <Route path='/' element={<Home />} />
          <Route path='/kontakt' element={<Kontakt />} />
          <Route path='/tipynavylety' element={<TipyNaVylety />} />
          <Route path='/jaksesbalitnahory' element={<JakSeSbalitNaHory />} />
          <Route path='/profile' element={<Profile />} />
          <Route path='/profile/forgetpassword' element={<ForgetPassword />} />
          <Route path='/profile/email-sended' element={<EmailSended />} />


          {/* BESKYDY  */}
          <Route path='/beskydy' element={<Beskydy />} />
          <Route path='/beskydy/kamsevydat' element={<KamSeVydatVBeskydech />} />

          <Route path='/beskydy/kamsevydat/lysahora' element={<LysaHora />} />
          <Route path='/beskydy/kamsevydat/pustevny' element={<Pustevny />} />
          <Route path='/beskydy/kamsevydat/velkyjavornik' element={<VelkyJavornik />} />

          <Route element={<PrivateRoute />}>
            <Route path='/beskydy/kamsevydat/moravka' element={<Moravka />} />
            <Route path='/beskydy/kamsevydat/javorovy' element={<Javorovy />} />
          </Route>


          {/* JESENÍKY */}
          <Route path='/jeseniky' element={<Jeseniky />} />
          <Route path='/jeseniky/kamsevydat' element={<KamSeVydatVJesenikach />} />

          <Route path='/jeseniky/kamsevydat/praded' element={<Praded />} />
          <Route path='/jeseniky/kamsevydat/serak' element={<Serak />} />
          <Route path='/jeseniky/kamsevydat/karlovastudanka' element={<KarlovaStudanka />} />
          
          <Route element={<PrivateRoute />}>
            <Route path='/jeseniky/kamsevydat/rejviz' element={<Rejviz />} />
            <Route path='/jeseniky/kamsevydat/medvedivrch' element={<MedvediVrch />} />
          </Route>


          {/* KRKONOŠE */}
          <Route path='/krkonose' element={<Krkonose />} />
          <Route path='/krkonose/kamsevydat' element={<KamSeVydatVKrkonosich />} />

          <Route path='/krkonose/kamsevydat/snezka' element={<Snezka />} />
          <Route path='/krkonose/kamsevydat/spindleruvmlyn' element={<SpindleruvMlyn />} />
          <Route path='/krkonose/kamsevydat/cernahora' element={<CernaHora />} />

          <Route element={<PrivateRoute />}>
            <Route path='/krkonose/kamsevydat/mumlavskyvodopad' element={<MumlavskyVodopad />} />
            <Route path='/krkonose/kamsevydat/zaly' element={<Zaly />} />
          </Route>
          

          {/* ŠUMAVA */}
          <Route path='/sumava' element={<Sumava />} />
          <Route path='/sumava/kamsevydat' element={<KamSeVydatNaSumave />} />

          <Route path='/sumava/kamsevydat/plechy' element={<Plechy />} />
          <Route path='/sumava/kamsevydat/boubin' element={<Boubin />} />
          <Route path='/sumava/kamsevydat/polednik' element={<Polednik />} />

          <Route element={<PrivateRoute />}>
            <Route path='/sumava/kamsevydat/vitkuvhradek' element={<VitkuvHradek />} />
            <Route path='/sumava/kamsevydat/chalupskaslat' element={<ChalupskaSlat />} />
          </Route>

        </Route>
      </Routes>
    </div>
  )
}

const Routing = () => {

  const { loading, user } = useUserContext()


  return (
    <>
      {loading ? <h2>Loading...</h2> : <>{user ? <Routing /> : <Auth />}</>}
    </>
  );
}

export default App;
